import { Customer, QueryRoot } from '@ts/shopify-storefront-api';
import fetchStorefrontApi from '../fetch-storefront-api';
import customerQuery from '../queries/customer-query';

export const getCustomer = async (token: string | undefined): Promise<Customer> => {
	if (!token) return null;
	const data: QueryRoot = await fetchStorefrontApi(customerQuery, { variables: { customerAccessToken: token } });
	return data.customer;
};
